import type { ThemeConfig } from '../types'
import { emberConfig as generated } from '../../generated/theme-presets'

// Ember: GLASSMORPHISM DARK. Not your dad's dark mode. Cards float like frosted glass
// panels over a warm gradient void. Coral and Honey glow out from behind surfaces.
// Borders are whisper-thin and semi-transparent. Shadows are colored halos, not black
// blobs. Wider sidebar for breathing room. Narrower content feels focused, intentional.
// Think Linear + Arc browser had a baby that went camping.
export const emberConfig: ThemeConfig = generated
